export const Roboto = "'Roboto', sans-serif"
export const TTMonoBold = '"TTInterphasesMono-Bold", monospace;'
export const TTReg = '"TTInterphases-Regular", monospace;'
export const TTMonoReg = '"TTInterphasesMono-Regular", monospace;'
